module.exports = __webpack_public_path__ + "static/media/sendBackward.e1291850.svg";